import React from "react";
import ProductCard from "components/ProductCard";
import RecentProductCard from "components/RecentProductCard";
import Container from "components/layout/Container";
import AnimatedMasoniteLogo from "components/AnimatedMasoniteLogo";
import Filters from "containers/Catalog/components/Filters";
import Pagination from "containers/Catalog/components/Pagination";
import s from "./index.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { productTypeNormalization } from "utility/routeTranslation";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { Header } from "containers/Catalog/components/Header";
import { FooterCTABoxes } from "./../../../../components/FooterCTABoxes";
import { createPublicUrlPath } from "containers/Catalog/helpers";
import { widenResize } from "helpers";
import { getHashPrefix } from "../../helpers";
import classNames from "classnames/bind";
import { language } from "utility/env";
import * as APPLICATIONS from 'constants/applications';

const cx = classNames.bind(s);

const Catalog = props => {
    const {
        aboveFooterContent,
        actions,
        history,
        location,
        pagination,
        products,
        loading,
        onOpenFilterDrawer,
        routeRoots,
        filterDrawerOpen,
        pathPrefix,
        webFontsLoaded,
        type
    } = props;

    const hasPrefix = prefix => hash => {
        return getHashPrefix(hash) === prefix;
    }

    const doors = (() => {
        return products
            ? products.map(product => {
                const application = product.application;

                let image = application[0]?.images[0] && application[0]?.images[0]?.image;

                  product = {
                      ...product,
                      image: widenResize(image, 250, 542, false)
                  };

                  return (
                      <ProductCard
                          {...product}
                          loading={loading}
                          to={`${routeRoots.productDetails}/${product.smart_hash}/${product.hash}`}
                          action={to => history.push(to)}
                          key={"rvp" + product.hash}
                      />
                  );
              })
            : [];
    })();

    const recentlyViewedProducts = props.recentlyViewedProducts
        .filter(v => v)
        .filter(product => product.hash) // prevents conflict with productDetails from RPSv1
        .map(product => (
            <RecentProductCard
                {...product}
                loading={loading}
                to={product.ProductUrl}
                action={to => {
                    const startOfPath = to.indexOf(routeRoots.productDetails);
                    history.push(to.slice(startOfPath));
                }}
                key={product.hash}
            />
        ));

    const resultsTotal = () => {
        if (!pagination) return false;

        const { from, to, total } = pagination;

        return (
            <p className={s.total}>
                <span className={cx(["total-label"])}>
                    {language === "fr" ? "Affichage" : "Viewing"}
                </span>{" "}
                {from}-{to} of {total}
            </p>
        );
    };

    const PaginationArea = ({ borderTop = false, borderBottom = false, marginBottom = false }) => {
        return (
            doors.length > 0 && (
                <div
                    className={cx([
                        "pagination-area",
                        borderTop && "pagination-area--border-top",
                        borderBottom && "pagination-area--border-bottom",
                        marginBottom && "pagination-area--margin-bottom"
                    ])}
                >
                    {resultsTotal()}
                    <Pagination
                        {...pagination}
                        action={nextPage => {
                            history.push(
                                createPublicUrlPath(
                                    pathPrefix,
                                    [],
                                    [],
                                    nextPage
                                )
                            );
                        }}
                        pathname={location.pathname}
                    />
                </div>
            )
        );
    };

    return (

        <>

        <Container>
            <div className={s.openFilterDrawerBtn} onClick={onOpenFilterDrawer}>
                <FontAwesomeIcon icon={faFilter} color="white" size="2x" />
            </div>
            <div className={s.grid}>
                <section className={s.productColumn}>
                    <div className={cx(["loadingIcon", { loading }])}>
                        <AnimatedMasoniteLogo centered />
                    </div>
                    <div className={cx(["loadingOverlay", { loading }])} />
                    <Header />
                    <PaginationArea borderBottom />
                    <div className={s.productGrid}>
                        {doors.length ? doors : "No doors found."}
                    </div>
                    <PaginationArea borderTop borderBottom marginBottom />
                    {recentlyViewedProducts.length > 0 && (
                        <>
                            <h3>{language === "fr" ? "Vu Récemment" : "Recently Viewed"}</h3>
                            <div className={cx([s.productGrid, s.recentProductsGrid])}>
                                {recentlyViewedProducts}
                            </div>
                        </>
                    )}
                </section>
            </div>
            <div className="before-footer">
                <div dangerouslySetInnerHTML={{ __html: aboveFooterContent }} />
            </div>
        </Container>

        <FooterCTABoxes />

        </>
    );
};

export default Catalog;
